import { render, staticRenderFns } from "./FloatLoginAndApplyTips.vue?vue&type=template&id=063d866c&scoped=true&"
import script from "./FloatLoginAndApplyTips.vue?vue&type=script&lang=js&"
export * from "./FloatLoginAndApplyTips.vue?vue&type=script&lang=js&"
import style0 from "./FloatLoginAndApplyTips.vue?vue&type=style&index=0&id=063d866c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063d866c",
  null
  
)

export default component.exports